import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from './ui/dialog';
import { Input } from './ui/input';

// import imgRectangle from "../assets/708d0f3eea92211817741311b4a4648b0ea18942.png";
import newElevationDay from "../assets/a4f6fed3904a1101cf897479ffc7a3faf413962d.png";
import newElevationEvening from "../assets/28f027090179452c4d3f2e32bef638c99fa5b239.png";
import reraApproved from "../assets/9e7d387c2e2f44f7bc977fddab25296b394c424a.png";
// Brochure PDF asset (ensure file name matches exactly)
import brochurePdf from "../assets/Blucon_Sunrise.pdf";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);





  const carouselImages = [
    {
      src: newElevationDay,
      alt: "Blucon Sunrise - Daytime Exterior View"
    },
    {
      src: newElevationEvening,
      alt: "Blucon Sunrise - Evening Exterior View"
    },
    {
      src: newElevationDay,
      alt: "Blucon Sunrise - Modern Apartment Complex"
    },
    {
      src: newElevationEvening,
      alt: "Blucon Sunrise - Luxury Living at Dusk"
    }
  ];



  const nextSlide = () => {
    setCurrentSlide((prev) => {
      const next = (prev + 1) % carouselImages.length;
      console.log('Next slide:', next);
      return next;
    });
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => {
      const previous = (prev - 1 + carouselImages.length) % carouselImages.length;
      console.log('Previous slide:', previous);
      return previous;
    });
  };

  // Auto-play carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  return (
    <section id="home" className="relative h-screen bg-gradient-to-br from-teal-50 via-white to-amber-50">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,rgba(20,184,166,0.1),transparent_70%)]"></div>

      {/* Mobile: Start immediately from top, Desktop: No top padding needed since nav is at bottom */}
      <div className="relative z-10 w-full h-full px-4 sm:px-6 lg:px-0">
        <div className="h-full pt-0 flex items-stretch">
          <div className="relative w-screen ml-[calc(-50vw+50%)] mr-[calc(-50vw+50%)]">
            {/* Carousel Container */}
            <div className="relative bg-white rounded-3xl shadow-2xl shadow-teal-200/30 overflow-hidden lg:rounded-none lg:shadow-none h-full">
              {/* Image Carousel */}
              <div className="relative w-full h-full overflow-hidden">
                {carouselImages.map((image, index) => (
                  <div
                    key={index}
                    className={`absolute inset-0 transition-all duration-[2000ms] ease-in-out ${
                      index === currentSlide 
                        ? 'opacity-100 scale-100' 
                        : 'opacity-0 scale-105'
                    }`}
                  >
                    <ImageWithFallback
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
                
                {/* Carousel Navigation Arrows */}
                <button
                  onClick={prevSlide}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-3 transition-all duration-200 group z-50 cursor-pointer"
                  aria-label="Previous image"
                >
                  <ChevronLeft className="w-6 h-6 text-white group-hover:text-amber-200 transition-colors" />
                </button>
                
                <button
                  onClick={nextSlide}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-3 transition-all duration-200 group z-50 cursor-pointer"
                  aria-label="Next image"
                >
                  <ChevronRight className="w-6 h-6 text-white group-hover:text-amber-200 transition-colors" />
                </button>
                
                {/* Carousel Indicators */}
                <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3 z-50">
                  {carouselImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                        index === currentSlide 
                          ? 'bg-amber-400 ring-2 ring-amber-200/50 scale-110' 
                          : 'bg-white/50 hover:bg-white/70'
                      }`}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
                
                {/* Get in Touch Button - Desktop */}
                <div className="absolute top-[50px] right-[320px] hidden lg:block z-40">
                  <Button
                    size="lg"
                    className="text-white font-semibold px-8 py-3 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 transform translate-x-[50px]"
                    style={{
                      background: 'linear-gradient(90deg,#ff7f00 0%,#ff9800 52%,#ffbd45 100%)',
                      border: '1px solid rgba(255,255,255,0.7)',
                      boxShadow: '0 5px 0 rgba(180,90,0,0.45)',
                      textShadow: '0 1px 2px rgba(0,0,0,0.25)',
                      borderRadius: '10px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = 'linear-gradient(90deg,#e86700 0%,#f27e00 52%,#ffb238 100%)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'linear-gradient(90deg,#ff7f00 0%,#ff9800 52%,#ffbd45 100%)'; e.currentTarget.style.transform = 'translateX(50px)'; e.currentTarget.style.boxShadow = '0 5px 0 rgba(180,90,0,0.45)'; }}
                    onMouseDown={(e) => { e.currentTarget.style.transform = 'translateX(50px) translateY(2px)'; e.currentTarget.style.boxShadow = '0 3px 0 rgba(160,80,0,0.55)'; e.currentTarget.style.background = 'linear-gradient(90deg,#d85d00 0%,#e67100 52%,#ff9e10 100%)'; }}
                    onMouseUp={(e) => { e.currentTarget.style.transform = 'translateX(50px)'; e.currentTarget.style.boxShadow = '0 5px 0 rgba(180,90,0,0.45)'; e.currentTarget.style.background = 'linear-gradient(90deg,#e86700 0%,#f27e00 52%,#ffb238 100%)'; }}
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    Get in Touch
                  </Button>
                </div>

                {/* RERA Approved Badge - Desktop with 400px margins */}
                <div className="absolute top-[100px] right-[300px] hidden lg:block z-30 group">
                  <div className="relative">
                    <ImageWithFallback
                      src={reraApproved}
                      alt="RERA Approved - Government Certified Project"
                      className="w-44 h-44 object-contain drop-shadow-2xl transition-all duration-300 group-hover:scale-110 group-hover:drop-shadow-3xl transform translate-x-[50px]"
                    />
                    
                    {/* Glowing effect on hover */}
                    <div className="absolute inset-0 bg-gradient-to-r from-amber-400/30 to-red-500/30 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-pulse transform translate-x-[50px]"></div>
                    
                    {/* Tooltip */}
                    <div className="absolute top-full mt-3 left-1/2 transform -translate-x-1/2 bg-white/95 backdrop-blur-sm text-teal-900 px-4 py-2 rounded-lg shadow-xl text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none border border-amber-200">
                      <div className="font-semibold text-red-600">RERA Approved Project</div>
                      <div className="text-xs text-gray-600 mt-1">Government Certified</div>
                      <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-white/95 rotate-45 border-l border-t border-amber-200"></div>
                    </div>
                  </div>
                </div>
                
                {/* Get in Touch Button - Mobile */}
                <div className="absolute top-[24px] right-[144px] lg:hidden z-40">
                  <Button
                    size="sm"
                    className="text-white font-semibold px-4 py-2 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 text-sm"
                    style={{
                      background: 'linear-gradient(90deg,#ff7f00 0%,#ff9800 52%,#ffbd45 100%)',
                      border: '1px solid rgba(255,255,255,0.7)',
                      boxShadow: '0 5px 0 rgba(180,90,0,0.45)',
                      textShadow: '0 1px 2px rgba(0,0,0,0.25)',
                      borderRadius: '10px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = 'linear-gradient(90deg,#e86700 0%,#f27e00 52%,#ffb238 100%)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'linear-gradient(90deg,#ff7f00 0%,#ff9800 52%,#ffbd45 100%)'; e.currentTarget.style.boxShadow = '0 5px 0 rgba(180,90,0,0.45)'; }}
                    onMouseDown={(e) => { e.currentTarget.style.transform = 'translateY(1px)'; e.currentTarget.style.boxShadow = '0 3px 0 rgba(160,80,0,0.55)'; e.currentTarget.style.background = 'linear-gradient(90deg,#d85d00 0%,#e67100 52%,#ff9e10 100%)'; }}
                    onMouseUp={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 5px 0 rgba(180,90,0,0.45)'; e.currentTarget.style.background = 'linear-gradient(90deg,#e86700 0%,#f27e00 52%,#ffb238 100%)'; }}
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    Get in Touch
                  </Button>
                </div>

                {/* RERA Badge - Mobile positioning */}
                <div className="absolute top-[74px] right-[124px] lg:hidden z-30 group">
                  <ImageWithFallback
                    src={reraApproved}
                    alt="RERA Approved"
                    className="w-40 h-40 sm:w-44 sm:h-44 object-contain drop-shadow-lg transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
              </div>
              


              {/* Text Content Overlay */}
              <div className="absolute inset-0 flex items-center z-40 pointer-events-none overflow-visible">
                <div className="w-full px-6 sm:px-8 lg:px-12 pointer-events-auto overflow-visible">
                  <div className="inline-block px-4 py-2 bg-white/50 backdrop-blur-sm rounded-full mb-6">
                    <span className="text-black">Experience Premium Living</span>
                  </div>
                  
                  <h1 className="font-bold mb-6 leading-tight overflow-visible">
                    <div className="flex flex-col items-start">
                      <div className="w-fit">
                        <div className="bg-gradient-to-b from-amber-400 to-amber-500 bg-clip-text text-transparent whitespace-nowrap overflow-visible" style={{fontSize: 'clamp(1.5rem, 5.5vw, 4rem)', letterSpacing: '0.05em', filter: 'drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.8)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.6))', fontFamily: 'Squada One'}}>BLUCON SUNRISE</div>
                      </div>
                      <div className="w-fit mt-2">
                        <div className="text-white whitespace-nowrap overflow-visible" style={{fontSize: 'clamp(0.69rem, 2.7vw, 2.09rem)', letterSpacing: '-0.02em', filter: 'drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.8)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.6))'}}>High UDS, Top Specs-Luxury Redefined</div>
                      </div>
                    </div>
                  </h1>
                  
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 mb-8 max-w-lg">
                    <ul className="text-lg sm:text-xl text-black leading-tight space-y-1">
                      <li className="flex items-center">
                        <span className="text-amber-400 mr-3 text-[28px] flex-shrink-0">•</span>
                        <span>Max UDS. Premium Space Ownership.</span>
                      </li>
                      <li className="flex items-center">
                        <span className="text-amber-400 mr-3 text-[28px] flex-shrink-0">•</span>
                        <span>Smart Design+Superior Specs.</span>
                      </li>
                      <li className="flex items-center">
                        <span className="text-amber-400 mr-3 text-[28px] flex-shrink-0">•</span>
                        <span>Exclusive Units | RERA Approved</span>
                      </li>
                    </ul>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row gap-4 relative">

                    <Dialog open={isContactOpen} onOpenChange={setIsContactOpen}>
                      <DialogTrigger asChild>
                        <Button
                          size="lg"
                          className="text-white font-semibold px-8 py-3 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
                          style={{
                            background: 'linear-gradient(90deg,#ff7f00 0%,#ff9800 52%,#ffbd45 100%)',
                            border: '1px solid rgba(255,255,255,0.7)',
                            boxShadow: '0 5px 0 rgba(180,90,0,0.45)',
                            textShadow: '0 1px 2px rgba(0,0,0,0.25)',
                            borderRadius: '10px',
                            cursor: 'pointer'
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = 'linear-gradient(90deg,#e86700 0%,#f27e00 52%,#ffb238 100%)'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = 'linear-gradient(90deg,#ff7f00 0%,#ff9800 52%,#ffbd45 100%)'; e.currentTarget.style.boxShadow = '0 5px 0 rgba(180,90,0,0.45)'; }}
                          onMouseDown={(e) => { e.currentTarget.style.transform = 'translateY(2px)'; e.currentTarget.style.boxShadow = '0 3px 0 rgba(160,80,0,0.55)'; e.currentTarget.style.background = 'linear-gradient(90deg,#d85d00 0%,#e67100 52%,#ff9e10 100%)'; }}
                          onMouseUp={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 5px 0 rgba(180,90,0,0.45)'; e.currentTarget.style.background = 'linear-gradient(90deg,#e86700 0%,#f27e00 52%,#ffb238 100%)'; }}
                        >
                          Download Brochure
                        </Button>
                      </DialogTrigger>
                      <DialogContent className="sm:max-w-4xl">
                        <DialogHeader>
                          <DialogTitle className="text-2xl text-center text-[#0c2125]">Download Brochure</DialogTitle>
                          <DialogDescription className="text-center text-gray-600">
                            Complete the form below to download our brochure. Our team will reach out shortly to share the best offers and help you schedule a site visit at your convenience.
                          </DialogDescription>
                        </DialogHeader>
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            if (isSubmitting) return;

                            const form = e.currentTarget as HTMLFormElement;
                            const formData = new FormData(form);
                            const name = (formData.get('name') as string || '').trim();
                            const email = (formData.get('email') as string || '').trim();
                            const phone = (formData.get('phone') as string || '').trim();

                            // Basic validation (HTML pattern & required already handle UI)
                            if (!name || !email || !phone) return; // safeguard

                            setIsSubmitting(true);

                            // Simulate async submit (e.g., could POST to API)
                            setTimeout(() => {
                              // Trigger brochure download
                              const link = document.createElement('a');
                              link.href = brochurePdf;
                              link.download = 'Blucon-Sunrise-Brochure.pdf';
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);

                              setIsSubmitting(false);
                              form.reset();
                              setIsContactOpen(false); // close dialog
                            }, 800);
                          }}
                          className="space-y-6"
                        >
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                              <Input
                                name="name"
                                placeholder="Your Name (Letters only)"
                                pattern="[A-Za-z\s]+"
                                title="Only letters and spaces are allowed"
                                required
                                className="h-12 px-4 bg-white border rounded-lg text-gray-600 placeholder-gray-400 focus:ring-1 border-gray-200 focus:border-teal-500 focus:ring-teal-500"
                              />
                            </div>
                            <div>
                              <Input
                                name="email"
                                type="email"
                                placeholder="Your Email"
                                required
                                className="h-12 px-4 bg-white border rounded-lg text-gray-600 placeholder-gray-400 focus:ring-1 border-gray-200 focus:border-teal-500 focus:ring-teal-500"
                              />
                            </div>
                            <div>
                              <Input
                                name="phone"
                                type="tel"
                                inputMode="numeric"
                                autoComplete="tel"
                                placeholder="Your Mobile (10 digits)"
                                pattern="^[0-9]{10}$"
                                title="Enter 10-digit mobile number (numbers only)"
                                maxLength={10}
                                required
                                className="h-12 px-4 bg-white border rounded-lg text-gray-600 placeholder-gray-400 focus:ring-1 border-gray-200 focus:border-teal-500 focus:ring-teal-500"
                              />
                            </div>
                          </div>
                          <div className="flex justify-center mt-6">
                            <Button 
                              type="submit"
                              disabled={isSubmitting}
                              className="bg-green-600 hover:bg-green-700 disabled:opacity-70 disabled:cursor-not-allowed text-white px-8 py-3 rounded-lg h-12 min-w-[200px] flex items-center justify-center gap-2 text-[16px]"
                            >
                              {isSubmitting ? 'Processing...' : 'Submit'}
                              {!isSubmitting && (
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                  <path fillRule="evenodd" d="M3 10a1 1 0 011-1h10a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                                </svg>
                              )}
                              {isSubmitting && (
                                <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <circle className="opacity-25" cx="12" cy="12" r="10" strokeWidth="4"></circle>
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                </svg>
                              )}
                            </Button>
                          </div>
                        </form>
                      </DialogContent>
                    </Dialog>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-8 h-8 text-teal-600" />
      </div>
    </section>
  );
};

export default HeroSection;